import { render } from "./ExportButton.vue?vue&type=template&id=104d84cc"
import script from "./ExportButton.vue?vue&type=script&lang=js"
export * from "./ExportButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\POS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__